module.exports = __webpack_public_path__ + "static/img/bg21.030caa12.png";